module.exports = __webpack_public_path__ + "img/53b1bea.svg";